<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right" v-if="project_id">
    <div style="margin-bottom:1px">
      <el-select size="mini" v-model="state" @change="modals" filterable placeholder="请选择组织" class="kuan" :data-val="isPermission(4003001001)" v-if="isPermission(4003001001)">
        <el-option
          v-for="(item,index) in [{name:'全部',value:0},{name:'待付款',value:1},{name:'已付款',value:2}]"
          :key="index"
          :label="item.name"
          :value="item.value">
        </el-option>
      </el-select>
      <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="isPermission(4003001001)">
        <el-option
          key=""
          label="全部"
          value="">
        </el-option>
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.company_name"
          :value="item.id">
        </el-option>
      </el-select>

      <!-- <el-select size="mini" v-model="value2" filterable placeholder="搜索选择" class="kuan">
        <el-option
          v-for="item in options1"
          :key="item.id"
          :label="item.label"
          :value="item.id">
        </el-option>
      </el-select> -->

      <el-select size="mini" v-model="chargeitemID" filterable placeholder="费用类型" class="kuan">
        <el-option
          key=""
          label="全部费用"
          value="">
        </el-option>
        <el-option
          v-for="item in chargeitem"
          :key="item.id"
          :label="item.chargeItem_name"
          :value="item.id">
        </el-option>
      </el-select>

      <!-- <el-input size="mini" class="search" placeholder="请输入搜索内容" v-model="search" clearable></el-input> -->
      <el-select
          v-model="search"
          class="search"
          size="mini"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="可搜索房产/客户姓名"
          :remote-method="remoteMethod"
          :loading="loading">
          <el-option
            v-for="item in selectList"
            :key="item.id"
            :label="item.house"
            :value="item.house">
          </el-option>
        </el-select>




      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
      <el-button size="mini" type="primary text2" style="margin-left: 1px;" @click="xiugai">费用收付</el-button>
      <!-- <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">导出欠费明细</el-button> -->
    </div>
    <div style="margin-bottom: 10px;display: flex;flex-wrap: wrap;">
      <div>收款方式：</div>
      <div v-for="it in dataPay">
          <div style="margin-left: 10px;">
            <el-radio v-model="radio" :label="it.number">{{it.name}}</el-radio>
          </div>
      </div>
    </div>
    <div style="display: flex;color: red;">
      <!-- <div>总金额：￥{{money}}元</div> -->
      <div v-if="sumMoney>0">总金额：￥{{sumMoney}}元</div>
      <div v-else>总金额：￥{{money}}元</div>
    </div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">ID</th>
              <!-- <th class="text-left">组织名称</th> -->
              <th class="text-left">姓名</th>
              <th class="text-left">房产名称</th>
              <th class="text-left">费用周期</th>
              <th class="text-left">费用名称</th>
              <th class="text-left">金额(实收)</th>
              <th class="text-left">金额(应收)</th>
              <th class="text-left">已缴金额</th>
              <th class="text-left">状态</th>
              <!-- <th class="text-left">生成日期</th> -->
              <th class="text-left">操作</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
            <tr class="text1" v-for="(item,index) in desserts" :key="item.id">
              <td><div style="display: flex;"><div v-if="item.state==1 && isPermission(4003001002)">
              <el-checkbox v-if="index==0" v-model="checked.checked0" @change="checkeds(1)" :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==1" v-model="checked.checked1" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==2" v-model="checked.checked2" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==3" v-model="checked.checked3" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==4" v-model="checked.checked4" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==5" v-model="checked.checked5" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==6" v-model="checked.checked6" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==7" v-model="checked.checked7" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==8" v-model="checked.checked8" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==9" v-model="checked.checked9" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==10" v-model="checked.checked10" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              <el-checkbox v-if="index==11" v-model="checked.checked11" @change="checkeds(1)"  :true-label='item.id'></el-checkbox>
              </div><div style="margin-left: 5px;">{{item.id}}</div></div></td>
              <!-- <td >{{item.company_name}}</td> -->
              <td >{{item.h_name}}<span v-if="!item.h_name">--</span></td>
              <td >
                  {{item.h_name_date}}
              </td>
              <td >{{item.startDate}}至{{item.endDate}}</td>
              <td ><span v-if="item.charge_name">{{item.charge_name}}</span><span v-else>{{item.xsc_ChargeName}}</span></td>
              <td >{{item.charge}}</td>
              <td >{{item.chargePay}}</td>
              <td >{{item.PaidChargeSum}}</td>
              <td ><span v-if="item.state==1">待支付</span><span v-if="item.state==2">已付款</span></td>
              <!-- <td >{{item.generate_date}}</td> -->
              <td class="cdj_td">
                <div style="cursor:pointer;" v-if="isPermission(4003001004)">
                  <div @click="chakan(item)">详情</div>
                </div>
                <div style="cursor:pointer;" v-if="item.state==1 && isPermission(4003007005)">
                  <div style="color: #1867c0;margin-left: 5px;" @click="reduction(item)">减免</div>
                </div>
                <div style="cursor:pointer;">
                  <div style="color: #1867c0;margin-left: 5px;" @click="bufen(item)">部分缴款</div>
                </div>
                <!-- <div style="cursor:pointer;" v-if="isPermission(4003001003)">
                  <div  style="color: red;margin-left: 5px;" @click="del( item.id )">删除</div>
                </div> -->
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change"  show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>

     <Modal
       v-model="modal12"
        ok-text="确定"
        width="500"
        title="查看详情">
        <div v-if="chakana['id']">
           <p>ID：{{chakana['id']}}</p>
           <p>房产ID：{{chakana['house_id']}}</p>
           <p>生成组ID：{{chakana['weiyi']}}</p>
           <p>编号：{{chakana['number']}}</p>
           <p>姓名：{{chakana['h_name']}}</p>
           <p>组织id：{{chakana['company_id']}}</p>
           <p>项目：{{chakana.h_name_date}}</p>
           <p>收费项：<span v-if="chakana.charge_name">{{chakana.charge_name}}</span><span v-else>{{chakana.xsc_ChargeName}}</span></p>
           <p>实收金额：{{chakana['charge']}}</p>
           <p>应收金额：{{chakana['chargePay']}}</p>
           <p>减免金额：{{chakana['discount']}}</p>
           <p>滞纳金额：{{chakana['delaySum']}}</p>
           <p>滞纳天数：{{chakana['delayDays']}}</p>
           <p>减免滞纳金额：{{chakana['delayDiscount']}}</p>
           <p>已缴金额：{{chakana['PaidChargeSum']}}</p>
           <p>状态：<span v-if="chakana.state==1">待支付</span><span v-if="chakana.state==2">已付款</span></p>
           <p v-if="chakana.remark != ''">备注：{{chakana['remark']}}</p>
           <p>生成时间：{{chakana['generate_date']}}</p>
           <p v-if="chakana.ymt1=='' && chakana.explain==''">仪表编号：{{chakana['ybiao']}}</p>
           <p v-if="chakana.ymt1=='' && chakana.explain==''">抄表读数：{{chakana['chaobiaodushu']}}</p>
           <p v-if="chakana.ymt1==''">抄表人或负责人：{{chakana['chaobiaoname']}}</p>
           <p v-if="chakana.explain != ''">收费说明：{{chakana['explain']}}</p>
           <p>计费开始：{{chakana.startDate}}</p>
           <p><span >计费结束：{{chakana.endDate}}</span></p>
           <p v-if="chakana['log_name']!=null">后台付款操作人：{{chakana['log_name']}}</p>
        </div>
     </Modal>
     <!-- 减免 -->
     <Modal
        v-model="reductions"
        ok-text="确定"
        width="500"
        @on-ok="cdj_reduction"
        title="减免(折扣)">
        <div>
          <div>收费金额：{{order.charge}}</div>
          <div>应收金额：{{order.chargePay}}</div>
          <div>已缴金额：{{order.PaidChargeSum}}</div>
          <div>滞纳天数：{{order.delayDays}}</div>
          <div>滞纳金额：{{order.delaySum}}</div>
          <div>减免金额：{{order.discount}}</div>
          <div>减免滞纳金额：{{order.delayDiscount}}</div>
          <RadioGroup v-model="buttonSize" type="button" style="margin-top:10px">
              <Radio label="1">按金额减免</Radio>
              <Radio label="2">按百分比减免</Radio>
          </RadioGroup>
          <div style="margin-top: 10px;">减免金额公式：原总金额 - 减免金额 = 需支付金额</div>
          <div>减免滞纳金公式：原滞纳金总金额 - 减免金额 = 需支付金额</div>
          <div style="color: red;">注意：当前欠费金额 {{order.charge}} - {{order.PaidChargeSum}} = {{money_charge}}</div>
          <br>
          <div>
            减 免 金 额：{{priceCharge}} -
            <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charge">
            = {{price}}
            <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage">%</span>
          </div>
          <div style="margin-top: 3px;">
            减免滞纳金：{{Number(order.delaySum)}} -
            <input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="charges">
            = {{prices}}
            <span v-if="buttonSize == 2" style="margin-left: 20px;"><input style="width: 50px;border: 1px solid #a2a2a2;text-align: center;" type="text" v-model="chargePercentage1">%</span>
          </div>
        </div>
     </Modal>

     <!-- 部分缴款 -->
     <Modal
        v-model="part"
        ok-text="确定"
        width="500"
        @on-ok="partAdd"
        title="部分缴款">
        <div>
          <div>收费金额：{{orderbuf.charge}}</div>
          <div>应收金额：{{orderbuf.chargePay}}</div>
          <div>已缴金额：{{orderbuf.PaidChargeSum}}</div>
          <div>
              <div style="margin-bottom: 10px;display: flex;flex-wrap: wrap;">
                <div>收款方式：</div>
                <div v-for="it in dataPay">
                    <div style="margin-left: 10px;">
                      <el-radio v-model="radio" :label="it.number">{{it.name}}</el-radio>
                    </div>
                </div>
              </div>
              <div class="demo-input-suffix" style="display: flex;margin-top: 10px;">
                <div style="width: 80px;margin-top: 3.5px;">缴款金额：</div>
                <el-input placeholder="缴款金额" style="width: 200px;" v-model="orderbuf.money" clearable></el-input>
              </div>
          </div>
        </div>
     </Modal>

    </div>
</div>

</template>

<script>
export default {
  name: 'OrderList',
  data () {
    return {
      selectList:[],
      radio:'',
      chargeitemID:'',
      chargeitem:[
        {
          'id':'',
          'chargeItem_name':''
        }
      ],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      checked:{
        checked0:'',
        checked1:'',
        checked2:'',
        checked3:'',
        checked4:'',
        checked5:'',
        checked6:'',
        checked7:'',
        checked8:'',
        checked9:'',
        checked10:'',
        checked11:'',
      },
      part:false,
      money:'--',
      modal12:false,
      loading:false,
      reductions:false,
      datevalue:[],
       options: [
        {
          value: '',
          label: ''
        },],
       options1: [
        {
          id: 1,
          label: '编号'
        },
        {
          id: 2,
          label: '姓名'
        },
        {
          id: 3,
          label: '身份证'
        },
        {
          id: 4,
          label: '房产'
        },
        ],
      value: '',
      value1:'',
      value2:4,
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      chakana:[],
      state:1,
      order:{
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        discount:0,
        delaySum:0,
        delayDays:0,
        delayDiscount:0,
      },
      orderbuf:{
        id:'',
        charge:0,
        chargePay:0,
        PaidChargeSum:0,
        money:0,
      },
      charge:0,
      price:0,
      charges:0,
      prices:0,
      priceCharge:0,
      itemOrder:[],
      homeName:'',
      dataPay:[],
      sumMoney:0,
      money_charge:0,
      project_id:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getorderList?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value = backdata.data;
        // this.$myhttp.get('admin/orderList?id=1'+'&company='+this.value +'&company1='+this.value2+'&t='+t+"&distinguish=0"+"&search="+this.search,{
        //   'Content-Type': 'application/json'
        //   }).then(backdata=>{ // 异步执行成功后
        //     this.desserts = backdata.data[0];
        //     this.total = backdata.data[1];
        //     this.page = backdata.data[2];
        //     this.$Loading.finish();
        //   ERP.hideLoading()
        // });
        this.change(1);
        this.moneys();
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
    });
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });

    //加载收款方式
    this.$myhttp.get('admin/OrderPayment/index',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
          let dataPay = backdata.data.data;
          this.dataPay = dataPay;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //部分缴款
    bufen(item){
      this.orderbuf = {
        id:item.id,
        charge:item.charge,
        chargePay:item.chargePay,
        PaidChargeSum:item.PaidChargeSum,
        money:0,
      },
      this.part = true;
    },
    partAdd(){
      this.orderbuf.radio = this.radio;
      this.$myhttp.post('admin/Order/part',this.orderbuf,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
             this.$Message.success(backdata.data.message);
             this.change(1)
          }else{
            this.$Message.error(backdata.data.message);
          }

      });
    },

    //核销金额合计
    checkeds(money,checked){
      this.$myhttp.post('admin/Order/money',{checked:this.checked},{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.sumMoney = backdata.data.money;
      });
    },
    //导出
    excelPost(){
      if(this.state != 1){
        this.$Message.error('点击待付款，选择费用类型导出');
        return false;
      }
      if(this.chargeitemID == ''){
        this.$Message.error('费用类型不能为空');
        return false;
      }
      this.$Loading.start();
      this.$myhttp.get('admin/getOrderExcel?id=1&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          console.log(333);
          this.$Loading.finish();
      });
    },
    //查询总欠费
    moneys(){
      this.$myhttp.get('admin/getMoney?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.money = backdata.data['money'];
      });
    },
    //减免（折扣）
    cdj_reduction(){
      var order = this.order;
      //收费金额
      var charge = this.price;
      //减免收费金额
      var discount = this.charge;
      //滞纳金额
      var delaySum = this.prices;
      //减免滞纳金额
      var delayDiscount = this.charges;
      var data = {
        id:order.id,
        charge:charge,
        discount:discount,
        delaySum:delaySum,
        delayDiscount:delayDiscount
      };
      var delaySum1 = Number(delaySum)+Number(delayDiscount);
      var charge1 = Number(charge)+Number(discount);
      if(delaySum1.toFixed(2) < Number(delayDiscount) || charge1.toFixed(2) < Number(discount)){
        this.$Message.error('金额不合法');
        return false;
      }
      this.$myhttp.post('admin/orderDiscount',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.searchs();
          this.$Message.success('操作成功!');
      });
      // console.log(data);
    },
    //弹窗查看
    chakan(e){
      // console.log(e);
      this.chakana = e;
      this.modal12 = true;
    },
    //减免
    reduction(item){
      this.itemOrder = item;
      if(this.reductions == false){
        this.buttonSize = "1";
        this.reductions = true;
      }
      this.order = item;
      //当前欠费
      this.money_charge = Number(this.order.charge) - Number(this.order.PaidChargeSum);
      this.money_charge = this.money_charge.toFixed(2);

      var delaySum = Number(this.order.delaySum)-Number(this.order.delayDiscount);
      var priceCharge = Number(this.order.charge) + Number(this.order.discount) - delaySum;
      this.priceCharge = priceCharge.toFixed(2);//原总金额
      this.charge = Number(item.discount);
      var priceCharges = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.order.discount) + Number(this.order.delayDiscount);
      this.price = priceCharges.toFixed(2);//收费金额
      this.charges = Number(item.delayDiscount);
      var prices = Number(item.delaySum) - Number(item.delayDiscount);
      this.prices = prices.toFixed(2);
    },
    //确定付款(核销,费用收付)
    xiugai(){
      if(this.radio == ""){
        this.$Message.error('请选择收款方式!');
        return false;
      }
      this.$confirm('确定核销吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listXiuGai',{checked:this.checked,'radio':this.radio},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading=false;
              if(backdata.data.code == 201){
                this.$Message.error(backdata.data.message);
              }
              if(backdata.data.code == 200){
                this.checked={
                  checked0:'',
                  checked1:'',
                  checked2:'',
                  checked3:'',
                  checked4:'',
                  checked5:'',
                  checked6:'',
                  checked7:'',
                  checked8:'',
                  checked9:'',
                  checked10:'',
                  checked11:'',
                };
                this.change(1)
                this.loading=false;
                this.$Message.success('操作成功!');
              }
          });
        }).catch(() => {

        });
    },
    modals(e){
      if(this.state != e){
        this.state = e;
        this.money = "--";
        this.change(1);
        this.moneys();
      }
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.$Loading.start();
      this.$myhttp.get('admin/orderList?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value2+"&state="+this.state+"&chargeitemID="+this.chargeitemID+"&homeName="+this.homeName,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/listDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                this.money = "--";
                this.change(1);
                this.$Message.success('删除成功!');
                this.moneys();
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get('admin/common/house_text?text='+query+'&project_id='+this.project_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
        });
      } else {
        this.selectList = [];
      }
    },
    // 树组件点击触发
    nodeClick(data) {
      this.sumMoney = 0;
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      // this.homeName=tree_str;
      // this.change(1);
      this.value2=4;
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        // this.remoteMethod(tree_str);
        this.change(1);
      }
    }
  },
  watch:{
      charge(){
        var price = Number(this.order.charge) + Number(this.order.discount) - Number(this.order.delaySum) - Number(this.charge) + Number(this.order.delayDiscount);
        this.price = price.toFixed(2);
        if(this.price < 0){
          this.$Message.error('减免金额不合法');
          return false;
        }
      },
      charges(){
        var prices = Number(this.order.delaySum) - Number(this.charges);
        this.prices = prices.toFixed(2);
        if(this.prices < 0){
          this.$Message.error('减免滞纳金额不合法');
          return false;
        }
      },
      //减免是按金额减免还是按百分比减免切换
      buttonSize(){
        this.chargePercentage = '';
        this.chargePercentage1 = '';
        this.reduction(this.itemOrder);
      },
      //减免金额百分比
      chargePercentage(){
        this.charge = Number(this.priceCharge)*(Number(this.chargePercentage)/100);
        this.charge = this.charge.toFixed(2);
      },
      //减免滞纳金百分比
      chargePercentage1(){
        this.charges = Number(this.order.delaySum)*(Number(this.chargePercentage1)/100);
        this.charges = this.charges.toFixed(2);
      },
  },

  components: {
    "erp-tree": () => import('../Common/erp-tree.vue')
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 300px;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/List.vue